
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.24 6.077a.48.48 0 01-.48-.48V.48a.48.48 0 11.96 0v5.117a.48.48 0 01-.48.48z","fill":"#343440"}}),_c('path',{attrs:{"d":"M22.3 24H1.719A1.7 1.7 0 01.02 22.3V4.263a1.7 1.7 0 011.7-1.699H22.3A1.7 1.7 0 0124 4.263V22.3A1.699 1.699 0 0122.3 24zM1.719 3.523a.74.74 0 00-.739.74V22.3a.749.749 0 00.74.739H22.3a.739.739 0 00.739-.74V4.263a.731.731 0 00-.74-.739H1.719z","fill":"#343440"}}),_c('path',{attrs:{"d":"M23.52 9.034H.48a.48.48 0 110-.96h23.04a.48.48 0 110 .96zM17.76 6.077a.48.48 0 01-.48-.48V.48a.48.48 0 01.96 0v5.117a.48.48 0 01-.48.48zM10.12 12.602c.454 0 .84.08 1.16.24.327.154.574.364.74.63.167.267.25.564.25.89 0 .314-.063.594-.19.84a1.45 1.45 0 01-.47.56.986.986 0 01-.58.2v.02c.254 0 .484.064.69.19.214.127.384.307.51.54.127.234.19.504.19.81 0 .36-.1.684-.3.97-.2.287-.483.51-.85.67-.36.16-.776.24-1.25.24-1.193 0-1.983-.533-2.37-1.6l.98-.47c.1.387.26.677.48.87.22.187.537.28.95.28.4 0 .714-.096.94-.29.227-.2.34-.463.34-.79 0-.36-.11-.613-.33-.76-.213-.153-.556-.23-1.03-.23h-.3v-.85h.27c.827 0 1.24-.34 1.24-1.02 0-.333-.096-.586-.29-.76-.186-.173-.453-.26-.8-.26-.353 0-.636.087-.85.26-.206.167-.34.407-.4.72l-.98-.4c.14-.48.41-.85.81-1.11.407-.26.887-.39 1.44-.39zm6.17.1v6.6h-1.05v-4.88c0-.226.003-.403.01-.53-.227.22-.487.41-.78.57-.287.16-.58.274-.88.34l-.2-.93c.173-.02.396-.093.67-.22.28-.126.543-.276.79-.45.246-.173.426-.34.54-.5h.9z","fill":"#343440"}})])
          )
        }
      }
    